<div class="grid thank-you-container full-height-grid mt-0">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content">
    <div class="thank-you-section">
      <span class="almost-done">
        {{ 'ThankYou.AlmostDone' | translate }}
      </span>
      <span class="thank-you-message">
        {{ 'ThankYou.ThankYouMessage_Part1' | translate }}
        <br />
        <br />
        {{ 'ThankYou.ThankYouMessage_Part2' | translate }}
      </span>
    </div>
    <div class="col-12">
      <div class="col-3 col-offset-5">
        <app-language-selector />
      </div>
    </div>
  </div>
</div>
